var _ukwhost = 'taglogstg-c2.ukw.jp';
var _ukwq = [];

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const CLIENT = 'brandchee';

    feedLog()

    async function feedLog() {
      _ukwq = []

      await sleep(2000)

      const commonLog = await getCommonLog()
      const searchLog = await getSearchLog()

      const logs = [
        ...commonLog,
        ...searchLog,
      ]

      for (const log of logs) {
        _ukwq.push(log)
      }

      console.log('Taglog ==>', _ukwq);
      (function () {
        var _ukt = document.createElement('script'); _ukt.type = 'text/javascript'; _ukt.async = true;
        _ukt.src = '//' + _ukwhost + '/taglog/ukwlg.js';
        var _uks = document.getElementsByTagName('script')[0]; _uks.parentNode.insertBefore(_ukt, _uks);
      })();
    }

    async function sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }

    async function getCommonLog() {
      let ret = [];
      ret.push(['_setClient', CLIENT]);
      ret.push(['_setReqURL', location.href]);
      ret.push(['_setRefURL', document.referrer]);
      ret.push(['_setDisplay', checkCustomerDevice()]);

      const customer_id = window.ShopifyAnalytics.meta.page.customerId;
      if (customer_id) {
        const hashedId = await hashWithSalt(customer_id)
        ret.unshift(['_setLoginID', hashedId]);
      }
      return ret
    }

    async function getSearchLog() {
      let ret = [];
      ret.push(['_setWord', getQueryParam('q')]);
      ret.push(['_setNumHit', getNumHit()]);
      ret.push(['_setNumDisp', "30"]);
      ret.push(['_setNumPage', getCurrentPage()]);
      ret.push(['_setSearchResult', getSearchResult()]);
      ret.push(['_setCategory', getCategory()]);
      ret.push(['_setBrand', getBrand()]);
      ret.push(['_setSort', getSort()]);
      ret.push(['_setFilter', getFilters()]);
      ret.push(['_sendSearchLog']);
      return ret
    }

    // idをソルト付きハッシュ化して返す関数
    // ソルトは任意の固定文字列（例: 'tokljasgoZKkkeipKX'）を使用
    async function hashWithSalt(id) {
      const salt = 'tokljasgoZKkkeipKX';
      const encoder = new TextEncoder();
      const data = encoder.encode(id + salt);
      const hashBuffer = await crypto.subtle.digest('SHA-256', data);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    }

    function checkCustomerDevice() {
      if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
        return 'sp';
      } else {
        return 'pc';
      }
    }

    function escapeHTML(text) {
      return text.replace(/\\/g, "&yen;")
        .replace(/'/g, "&#x27;")
        .replace(/"/g, '&quot;')
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
    }

    function getTextFromHTML(selector) {
      const target = document.querySelector(selector);
      if (!target) { return '' }
      return target.textContent.trim()
    }

    function getQueryParam(key) {
      const val = new URL(location.href).searchParams.get(key)
      return val == null ? '' : escapeHTML(val).trim()
    }

    function existsQueryParam(key) {
      return (new URLSearchParams(location.search)).has(key)
    }

    function getNumHit() {
      return document.querySelectorAll('[data-original-product-id]').length;
    }

    function getCurrentPage() {
      const page = getQueryParam('page');
      return page == null || page == '' ? "1" : page
    }

    function getSearchResult() {
      const products = document.querySelectorAll('[data-original-product-id]');
      if (!products) { return "" }

      const list = new Set()
      for (const p of products) {
        const id = p.dataset["originalProductId"];
        if (!id) { continue }
        list.add(id)
      }
      return Array.from(list).join(",")
    }

    function getCategory() {
      const param = getQueryParam('rb_snize_facet1')
      if (!param) { return '' }
      return param.split('|').join(',');
    }

    function getBrand() {
      const param = getQueryParam('rb_vendor')
      if (!param) { return '' }
      return param.split('|').join(',');
    }

    function getSort() {
      return getQueryParam('sort_by') ?? '';
    }

    function getFilters() {
      return [
        "rb_price",
        "rb_snize_facet3",
        "rb_discount_relative",
        "rb_stock_status",
      ].flatMap(filterKey => existsQueryParam(filterKey) ? filterKey : [])
        .join(",");
    }

  });
})();